import { FormattedMessage } from 'react-intl';

import { useStyle } from '@/classify';
import { cn } from '@/lib/utils';
import defaultClasses from './field.module.css';
const Field = props => {
  const { children, id, label, optional, icon, required } = props;
  const classes = useStyle(defaultClasses, props.classes);
  const optionalSymbol = optional ? (
    <span className={classes.optional}>
      <FormattedMessage
        id={'field.optional'}
        defaultMessage={'Optional'}
      />
    </span>
  ) : null;

  const maybeIcon = icon || null;

  const labelTextClass = icon ? classes.iconLabelText : classes.labelText;

  const labelClass = required ? classes.requiredLabel : classes.label;

  const maybeLabel = label ? (
    <label
      className={labelClass}
      htmlFor={id}
    >
      <span className={classes.labelHeader}>
        {maybeIcon}
        <span className={labelTextClass}>{label}</span>
      </span>
      {optionalSymbol}
    </label>
  ) : null;

  return (
    <div className={cn(defaultClasses.hideSmall, classes.root)}>
      {maybeLabel}
      {children}
    </div>
  );
};

export default Field;
